import { Add } from '@mui/icons-material';
import { Button } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import {
  WorkspaceSetupDialog,
  useWorkspaceSetupDialog,
} from '~/scenes/MyWorkspace/components/WorkspaceToolbar/components/WorkspaceToolbarReadMode/components/WorkspaceSetupDialog';
import { useWorkspaceToolbarReadMode } from '~/scenes/MyWorkspace/components/WorkspaceToolbar/components/WorkspaceToolbarReadMode/useWorkspaceToolbarReadMode';
import { WorkspaceSettings } from '~/scenes/MyWorkspace/userSettings';

type PropsType = {
  workspaces: WorkspaceSettings[];
};

export const AddWorkspaceButton = (props: PropsType) => {
  const { t } = useTranslation();
  const { workspaces } = props;

  const {
    dialogOpen,
    handleDialogOpen,
    handleDialogClose,
    handleDialogSubmit,
    formSettings,
  } = useWorkspaceSetupDialog();

  const { handleCreateWorkspace } = useWorkspaceToolbarReadMode({
    handleSetupDialogOpen: handleDialogOpen,
  });

  return (
    <>
      <Button onClick={() => handleCreateWorkspace()} startIcon={<Add />}>
        {t('createWorkspace')}
      </Button>

      <WorkspaceSetupDialog
        open={dialogOpen}
        onClose={handleDialogClose}
        onSubmit={handleDialogSubmit}
        formSettings={formSettings}
        workspaces={workspaces}
      />
    </>
  );
};
